module.exports = __webpack_public_path__ + "assets/fonts/Acens.c0074d16.ttf";